module.exports = __webpack_public_path__ + "static/media/orientacion-psicologica.4097d0dc.svg";